module.exports = __webpack_public_path__ + "static/img/peixun.a5ae9b2b.jpg";